import { Link } from "react-router-dom";
import u from "../../ui/ui.module.css";

export default function AuthButtonLink({
  to,
  href,
  children,
  variant = "primary",
  block = true,
  className = "",
  style,
  ...rest
}) {
  const classes = [
    u.btn,
    variant === "ghost" ? u.btnGhost : u.btnPrimary,
    u.btnLg,
    block ? u.btnBlock : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const linkStyle = { textDecoration: "none", ...style };

  if (href) {
    return (
      <a href={href} className={classes} style={linkStyle} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={classes} style={linkStyle} {...rest}>
      {children}
    </Link>
  );
}
